import moment from "moment";
export const overviewMixin = {
    methods: {
        async fetchBarChartData(durationType, dataType) {
            const payload = {
                type: durationType,
                ...this.getDurationCollection(),
            };

            const response = await this.$store.dispatch(
                "ride/over_view_bar_chart_data",
                payload
            );

            if (response.success) {
                return this.formatResponseForBarChart(
                    durationType,
                    dataType,
                    response.data
                );
            }

            // fall back to an empty (but well-formed) dataset so the chart prop
            // is always an Object — never `false`
            return this.getEmptyChartData(durationType, dataType);
        },

        formatResponseForBarChart(durationType, dataType, data = []) {
            // Handle empty data case
            if (!data || data.length === 0) {
                return this.getEmptyChartData(durationType, dataType);
            }

            const labels = data.map((item) => {
                if (durationType == "week") {
                    // item.date should be the day number (1-31)
                    // Create a date for current month with that day
                    const currentMonth = moment().month();
                    const currentYear = moment().year();
                    return moment()
                        .year(currentYear)
                        .month(currentMonth)
                        .date(item.date)
                        .format("DD/MM/YYYY");
                } else if (durationType == "month") {
                    // For month view, item.date is the week number
                    return "W" + item.date;
                } else if (durationType == "year") {
                    // For year view, item.date is the month number (1-12)
                    return moment()
                        .month(item.date - 1)
                        .format("MMM");
                }

                return new Date().getFullYear();
            });

            const datasets = data.map((item) =>
                dataType === "elevation" ? item.elevation : item.distance
            );

            return {
                labels: labels,
                datasets: [
                    {
                        label: dataType === "elevation" ? "Elevation" : "Distance",
                        backgroundColor: dataType === "elevation" ? "#fcb813" : "#357fdd",
                        data: datasets,
                        borderColor: "#ffffff",
                        borderWidth: 2,
                        barThickness: 30,
                        maxBarThickness: 50,
                    },
                ],
            };
        },
        getEmptyChartData(durationType, dataType) {
            let labels = [];

            if (durationType === "week") {
                // Generate 7 days for current week
                const startOfWeek = moment().startOf("week");
                labels = Array.from({ length: 7 }, (_, i) =>
                    startOfWeek.clone().add(i, "days").format("DD/MM/YYYY")
                );
            } else if (durationType === "month") {
                // Generate weeks for current month (W1, W2, W3, W4, W5)
                const weeksInMonth = Math.ceil(moment().daysInMonth() / 7);
                labels = Array.from({ length: weeksInMonth }, (_, i) => `W${i + 1}`);
            } else if (durationType === "year") {
                // Generate all 12 months
                labels = moment.months().map((month) => month.substring(0, 3));
            }

            return {
                labels: labels,
                datasets: [
                    {
                        label: dataType === "elevation" ? "Elevation" : "Distance",
                        backgroundColor: dataType === "elevation" ? "#fcb813" : "#357fdd",
                        data: Array(labels.length).fill(0),
                        borderColor: "#ffffff",
                        borderWidth: 2,
                        barThickness: 30,
                        maxBarThickness: 50,
                    },
                ],
            };
        },
        getDurationCollection() {
            return {
                year: new Date().getFullYear(),
                month: new Date().getMonth() + 1,
                week: this.getWeekOfMonth(),
            };
        },

        getWeekOfMonth() {
            const date = new Date();
            const dayOfMonth = date.getDate();

            if (dayOfMonth < 8) return 1;
            if (dayOfMonth < 15) return 2;
            if (dayOfMonth < 22) return 3;
            if (dayOfMonth < 29) return 4;
            return 5;
        },
    },
};
